import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

 
import InputPagger from "../../helpers/InputPagger";
import InputDateTime from "../../helpers/InputDateTime";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import QueryDet from "./QueryDet";
import QueryNew from "./QueryNew";

 
 


function Query(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
       
       // fraza: '', 

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_news,ankiety', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(filterParam[filedName] != val && val.length == 0)
        setTab(null);  
    }



    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterClear = () => {
        setFilterParam({    
            //fraza: '',    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            
            limit: 50,
            page: 1,
        });
        setTab(null);
    }


    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }





    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć ankietę " , "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

 
    

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_news,ankiety_usun', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Ankieta została usunięta", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


   

    var sortList = [  
        {column: "created_at", name: "Data utworzenia"  }, 
    ]
 


    

    if(view.v == 'new')
        {
         
            return <QueryNew  userData={props.userData} mainView={props.mainView}   onBack={onBack} />
        }



    if(view.v == 'edit')
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <QueryDet  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack} />
        }

    

    return (

        <div className="view_content">
         


          



            <div className="bg_center">


                    <div className="table_widget">      

                              <div className="btn" onClick={changeView} v="new" id="-1"  > nowa ankieta</div>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />
                    </div>
 

                    <div className="scorll_x">
                            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td className="">Data utworzenia</td>                                        
                                                <td className="">Pytanie</td>                                                                                                                                      
                                                <td className="">Liczba uczestników</td>                                                                                                                                      
                                                <td className="td_right">Udzielonych odpowiedzi</td>   
                                                <td className="td_option "> </td>                                                                                                                                   
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter">{row.created_at }</td>                                                                                                  
                                                            <td className="goleft link_normal" onClick={changeView} v="edit" id={row.id} >{row.pytanie   }</td>                                                                                                  
                                                            <td className="gocenter">{row.ilosc_uczestnikow }</td>                                                                                                  
                                                            <td className="gocenter ">{row.ilosc_odp }</td>                                                                                                  
                                                            
                                                            <MenuTable>
                                                                        <ul>
                                                                            <li onClick={changeView} v="edit" id={row.id} >pokaż</li> 
                                                                            <li onClick={goDelete}  id={row.id} >usuń</li>                                                                           
                                                                        </ul>
                                                            </MenuTable>

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>

            </div>


        </div>

    )

}

export default Query;